// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;He shall drink from the brook beside the way;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;therefore shall he lift high his head.<br> </p> </div></div>";
// Exports
module.exports = code;